module.exports = __webpack_public_path__ + "static/media/ticktick.56a63b6b.mp3";